import { render, staticRenderFns } from "./LoyaltyCertAddComponent.vue?vue&type=template&id=4e66ae2d&scoped=true"
import script from "./LoyaltyCertAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCertAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66ae2d",
  null
  
)

export default component.exports